import { initRequestRuntime } from "./mockUtils";
import { isMobile, ImportBundle } from "./utils";
/*! 公共 Start */
/**
 * 头部搜索下拉
 * @function initSearch
 * @param {string} search ".header-search_box"
 * @param {string} trigger ".search-trigger"
 **/
export function initSearch(search = ".header-search_box", trigger = ".search-trigger") {
  const searchBox = $(`.pc-header ${search}`);
  if (!searchBox.length || !trigger) return;
  $(`.pc-header ${trigger}`).on("click", (event) => {
    searchBox.slideToggle(500);
    $(document).one("click", () => {
      searchBox.slideUp(500);
    });
    event.stopPropagation();
  });
  searchBox.on("click", (event) => {
    event.stopPropagation();
  });
}

/**
 * 全局搜索方法
 * @function globalSearch
 * 公共初始化所有"form.searchForm"类的的表单，注册submit事件
 *
 **/
export function globalSearch() {
  $("form.searchForm").on("submit", (event) => {
    const form = event.target;
    const module = (form.querySelector("[name=module]")! as HTMLInputElement).value;
    const keyword = (form.querySelector("[name=keyword]")! as HTMLInputElement).value;
    if (!keyword || keyword === "") {
      alert("Please enter your search");
      return false;
    }
    window.location.href = `/search/${module}/${keyword}.html`;
  });
}

/** 固定头部滚动逻辑配置 */
export interface FixedHeaderOptions {
  /** header 的类名(不含前缀 header.)，例如传入 "pc-header" */
  id: string;
  /** 进入固定状态附加的类，默认 header-fixeds_1 */
  className?: string;
  /** 触发固定的滚动高度，默认取 header 自身高度 */
  H?: number;
  /** 当进入固定状态时触发（仅在状态变化为 fixed 时调用一次） */
  onFixeds?: (header: JQuery<HTMLElement>) => void;
  /** 当离开固定状态时触发（返回 false 可阻止默认立即移除 fixed 类） */
  onUnfixed?: (header: JQuery<HTMLElement>) => boolean | void;
}

/**
 * 头部导航栏 Fixed
 * 用法：
 * fixedsHeader('pc-header');
 * fixedsHeader('pc-header', 'my-fixed', 120, () => {...});
 * fixedsHeader({ id: 'pc-header', className: 'my-fixed', H: 120, onFixeds: () => {...} });
 */
export function fixedsHeader(id: string, className?: string, H?: number): void;
export function fixedsHeader(options: FixedHeaderOptions): void;
export function fixedsHeader(idOrOptions: string | FixedHeaderOptions, className = "header-fixeds_1", H?: number): void {
  const opts: FixedHeaderOptions =
    typeof idOrOptions === "string" ? { id: idOrOptions, className: className || "header-fixeds_1", H } : { className: "header-fixeds_1", ...idOrOptions };

  const header = $(`header.${opts.id}`);
  if (!header.length) return;
  const threshold = typeof opts.H === "number" ? opts.H : header.height()!;
  const fixedCls = `${opts.className || "header-fixeds_1"} isFixed`;
  let isFixed = false;

  if (isMobile(1024)) {
    bindMobileHeader(header);
    return;
  }
  const handleFixed = () => {
    const top = $(window).scrollTop()!;
    if (top > threshold) {
      if (!isFixed) {
        header.addClass(fixedCls);
        isFixed = true;
        opts.onFixeds && opts.onFixeds(header);
      }
    } else if (top === 0) {
      // 离开固定（回到顶部）
      if (isFixed) {
        const shouldRemoveImmediately = opts.onUnfixed?.(header) !== false;
        if (shouldRemoveImmediately) {
          header.removeClass(fixedCls);
        }
        isFixed = false;
      }
    }
  };

  $(window).on("scroll.fixedsHeader", handleFixed);
  handleFixed();
}

export function bindMobileHeader(header: JQuery<HTMLElement>) {
  header.find(".trigger").on("click", function () {
    $(this).toggleClass("trigger_active");
    $(this).siblings(".content_mt_ul").slideToggle(300);
  });
  header.find(".mobile_nav .nav_bg").on("click", function () {
    $("html").css("overflow-y", "unset");
    $(".mobile_nav .mobile_nav_content").removeClass("nav_show");
  });
  header.find(".mobile_nav .cus-bars").on("click", function () {
    $("html").css("overflow-y", "hidden");
    $(".mobile_nav .mobile_nav_content").addClass("nav_show");
  });
}

/**
 * 懒加载 并 初始化FancyBox
 * @function initFancyBox
 **/
export function initFancyBox() {
  window.swiperGroup;
  ImportBundle({ type: "css", isIndex: true }, ["https://static.yigetechcms.com/public/css/fancybox@5.0.0.min.css"]);
  ImportBundle({ type: "js", isIndex: true }, [
    {
      src: "https://static.yigetechcms.com/public/js/fancybox@5.0.0.min.js",
      fn: () => {
        if (window && window.Fancybox) {
          window.Fancybox.bind("[data-fancybox]", {
            Thumbs: {
              type: "classic",
            },
            caption(instance, slide, caption) {
              const { fancyboxTitle, fancyboxDescription } = (slide as unknown as { fancyboxTitle?: string; fancyboxDescription?: string }) || {};
              const title = typeof fancyboxTitle === "string" ? fancyboxTitle : "";
              const description = typeof fancyboxDescription === "string" ? fancyboxDescription : "";
              if (!title && !description) return false;
              const titleMarkup = title ? `<h3 class='fancybox-title'>${title}</h3>` : "";
              const descriptionMarkup = description ? `<div class='fancybox-description'>${description}</div>` : "";
              return `
              <div class='fancybox-text_wrap'>
                ${titleMarkup}
                ${descriptionMarkup}
              </div>
              `;
            },
            Toolbar: {
              display: {
                left: ["infobar"],
                middle: ["zoomIn", "zoomOut", "toggle1to1", "rotateCCW", "rotateCW", "flipX", "flipY"],
                right: ["slideshow", "thumbs", "close"],
              },
            },
          });
        }
      },
    },
  ]);
}

/**
 * 懒加载 并 初始化Addtoany
 * @function initFancyBox
 **/
export function initAddToAny() {
  ImportBundle({ type: "js" }, [
    {
      src: "https://static.addtoany.com/menu/page.js",
      async: true,
      fn: () => {
        const a2a_config = window.a2a_config || {};
        window.a2a_config = a2a_config;
      },
    },
  ]);
}

// /**
//  * 回到顶部
//  * @function initToTop
//  * @param el 绑定的元素 e.g. ".toTop"
//  * @param time 动画执行所需时间
//  */
export function initToTop(el: string, time: number = 500) {
  if ($(el).length) {
    $(el).on("click", () => {
      $("html").css("scroll-behavior", "unset");
      $("html,body").animate({ scrollTop: 0 }, time);
      setTimeout(() => {
        $("html").css("scroll-behavior", "");
      }, time);
    });
  }
}

export function addDefaultTabelStyle() {
  $("table").addClass("table table-bordered table-striped");
  if ($(window).width()! <= 1024) {
    $("table").wrap('<div class="table-responsive"></div>');
  }
}

/**
 * @function mainInit
 * @description 主入口函数，页面所有初始化函数均在此顺序调用，确保所有 DOM 元素均已加载完成，懒加载。
 * @param {Array<() => void>} func 需要执行的初始化函数数组
 */
export const mainInit = (func: Array<() => void>) => {
  $(function () {
    if (window.innerWidth === 1350 || window.innerWidth === 412) {
      $(document).one("mousemove", () => {
        main();
      });
      $(document).one("touchmove", () => {
        main();
      });
      $(document).one("scroll", () => {
        main();
      });
    } else {
      main();
    }
  });
  let main = () => {
    initRequestRuntime();
    func.forEach((fn) => fn());
    main = () => {};
  };
};

/**
 * @function forceInitialScrollTop
 * @description 强制在页面初始加载时将 scrollTop 设置为 0，解决某些浏览器在页面刷新或返回时自动滚动到之前位置的问题。
 */
export const forceInitialScrollTop = () => {
  if (typeof window === "undefined" || window.location.hash) return;
  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  const body = document.body;
  if (body) {
    body.scrollTop = 0;
  }
};

interface ScrollToTopHandlerOptions {
  // time?: number;
  hideInOffset?: number;
  offset?: number;
}
export const createScrollToTopHandler = (el?: JQuery<HTMLElement>, options?: ScrollToTopHandlerOptions) => {
  // const headerHeight = $("header.page__header").outerHeight() || 0;
  if (el && !el.length) return;
  const { offset = 0, hideInOffset = 500 } = options || {};
  const primitiveBehavior = $("html").css("scroll-behavior") || "auto";
  const handleClick = () => {
    window.scrollTo({ top: offset, left: 0, behavior: "smooth" });
    requestAnimationFrame(() => {
      $("html").css("scroll-behavior", primitiveBehavior);
    });
  };
  const renderer = () => {
    const button = $(`<button type="button" id='Totop' class='topTopBtn' aria-label='Back to top'></button>`);
    const icon = $(`
      <div class='i'>
        <svg viewBox="0 0 1024 1024"><path d="M698.176 490.666667H554.666667v426.666666h-85.333334V490.666667h-143.509333c-18.56 0-28.266667-22.058667-15.722667-35.754667l186.176-203.093333a21.333333 21.333333 0 0 1 31.445334 0l186.176 203.093333c12.544 13.696 2.837333 35.754667-15.722667 35.754667zM917.333333 192V106.666667H106.666667v85.333333h810.666666z"></path></svg>
      </div>
      `);
    button.append(icon);
    const styleSheet = $(
      `<style>.topTopBtn{all:unset;box-sizing:border-box;position:fixed;right:var(--mini-gap,3rem);bottom:25%;z-index:20;border-radius:50%;overflow:hidden}.topTopBtn .i{--icon-color:#ffffff;display:flex;justify-content:center;align-items:center;border-radius:50%;cursor:pointer;width:6.1rem;height:6.1rem;flex-shrink:0;border:1px solid var(--themeColor,#000);background-color:var(--themeColor,#000);color:var(--icon-color);overflow:hidden;font-size:2rem;line-height:1;transition:.45s var(--ease-power3-out,ease-out)}.topTopBtn .i:hover{--icon-color:var(--themeColor, #000000);background-color:#fff}.topTopBtn .i i{transition:inherit;color:inherit;font-size:inherit;line-height:inherit;font-weight:inherit}.topTopBtn .i svg{width:50%;height:50%;fill:var(--icon-color);stroke-width:0;stroke:none;transition:inherit}@media screen and (max-width:620px){.topTopBtn .i{width:4.8rem;height:4.8rem}}</style>`,
    );
    $("body").append(styleSheet);
    return button;
  };
  const target = el?.length ? el : renderer();
  if (hideInOffset > 0) {
    $(window).on("scroll", () => {
      const scrollTop = $(window).scrollTop() || 0;
      if (scrollTop > hideInOffset) {
        target.fadeIn();
      } else {
        target.fadeOut();
      }
    });
  }
  target.on("click", handleClick);
  requestAnimationFrame(() => {
    if (!el || el.length) {
      $("body").append(target);
    }
  });
};
